import React from 'react';
import { Box, Icon, Tooltip, Typography } from '@material-ui/core';

/**
 * Heading for one block inside a SectionCard.
 *
 * Exists because some cards answer a single question with more than one
 * setting - "when does this cluster switch itself off" has both a fixed timer
 * and an idle rule - and those settings have to be readable side by side
 * without each one claiming a card of its own. Deliberately quieter than
 * SectionCard's header: same shape, one step down in weight, so the card still
 * reads as the unit.
 */
const headingStyle = {
    fontSize: '14px',
    fontWeight: 600,
    color: '#0f2147',
};

const iconStyle = {
    fontSize: '18px',
    marginRight: '8px',
    color: '#2196F3',
};

const tooltipIconStyle = {
    fontSize: '16px',
    marginLeft: '4px',
    color: '#6b778c',
    verticalAlign: 'middle',
    cursor: 'help',
};

export default function SubSectionHeading({ icon, title, tooltip }) {
    return (
        <Box display="flex" alignItems="center" style={{ marginBottom: 8 }}>
            {icon && <Icon style={iconStyle}>{icon}</Icon>}
            <Typography style={headingStyle}>{title}</Typography>
            {tooltip && (
                <Tooltip title={tooltip}>
                    <Icon style={tooltipIconStyle}>help_outline</Icon>
                </Tooltip>
            )}
        </Box>
    );
}
